/**
 * 会员信息
 */
import React from 'react';

import { Input, Row, Col, Icon, Tooltip, Button, TreeSelect } from 'antd';

import PageLayout from '../../ui/PageLayout';
import TenantPropertyEdit from './TenantPropertyEdit';

import orgUtil from '../../ui/orgUtil';

import http from '../../../axios/http';
import messager from '../../ui/messager';//充值
import MemberPropertyRecharge from '../member/MemberPropertyRecharge';
//扣款
import MemberPropertyDeduction from '../member/MemberPropertyDeduction';
//详情
import MemberDetail from '../member/MemberDetail';
//代办公司下属用户维护
import MemberTeam from '../member/MemberTeam';
import { global_data } from '../../ui/auth'


class TenantProperty extends React.Component {

    columns = [{
        title: '所属市场',
        dataIndex: 'orgName',
        width: '10%',
    }, {
        title: '商户名称',
        dataIndex: 'memberName',
        width: '10%',
    }, {
        title: '联系人',
        dataIndex: 'contactMan',
        width: '10%',
    }, {
        title: '联系人电话',
        dataIndex: 'contactNumber',
        width: '10%',
    }, {            
        title: '车位数', 
        dataIndex: 'parkingNumber',
        width: '10%',
    }, {            
        title: '物管费余额', 
        dataIndex: 'propertyAccount',
        width: '10%',
    },{            
        title: '水费', 
        dataIndex: 'waterFees',
        width: '10%',
    },{            
        title: '电费', 
        dataIndex: 'electricityFee',
        width: '10%',
    }
    ,{
        title: '操作',
        dataIndex: 'memberCode',
        width: '20%',
        render: (text, record, index) => (
            <div>
                {global_data.authCode.includes("TENANTPROPERTY_UPDATE")?
                <Tooltip title="修改">
                    <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.update.bind(this, record)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("TENANTPROPERTY_DELETE")?
                <Tooltip title="删除">
                    <Icon type="delete" theme="filled" className="table-operate-icon" onClick={this.delete.bind(this, text)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("TENANTPROPERTY_MEMBER")?
                <Tooltip title="人员配置">
                    <Icon type="team" className="table-operate-icon" onClick={this.updateTeam.bind(this, record)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("TENANTPROPERTY_RECHARGE")?
                <Tooltip title="物管费充值">
                    <Icon type="money-collect" theme="filled" className="table-operate-icon" onClick={this.doRecharge.bind(this, record)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("TENANTPROPERTY_DEDUCTION")?
                <Tooltip title="扣款">
                    <Icon type="transaction" className="table-operate-icon" onClick={this.deduction.bind(this, record)} />
                </Tooltip>
                :""}
                <Tooltip title="明细">
                    <Icon type="eye" theme="filled" className="table-operate-icon" onClick={this.detail.bind(this, record)} />
                </Tooltip>
            </div>
        )
    }];

    state = {
        visible: false,
        editData: {},
        loadData: '',
        queryData: {},
        orgList: [],
        rechargeVisible: false, //充值
        deductionVisible: false, //扣款
        detailVisible: false, //明细

        summary: {}
    };

    componentDidMount() {
        orgUtil.findOrg(
            { orgType: 4 },   //只查询市场的组织信息
            (res) => {
                this.setState({ orgList: res });
            }
        );
    }

    showModal = () => {
        this.setState({ visible: true });
    };
    hiddenModal = () => {
        this.setState({ visible: false, editData: {} });
    };

    add = () => {
        this.setState({ editData: {} });
        this.showModal();
    }

    update = (info, e) => {
        this.setState({ editData: info });
        this.showModal();
    }

    delete = (info, e) => {
        messager.confirm("是否删除该租户信息？", () => {
            http.post({
                url: "/tenant/deleteTenant",
                data: { memberCode: info },
                success: (res) => {
                    this.state.loadData(this.state.queryData);
                    messager.notify("删除成功！");
                }
            });
        });
    }

    ///代办人员维护
    updateTeam = (info, e) => {
        info.code = info.memberCode;
        info.name = info.memberName;
        this.refs["memberTeam"].initData(info.code,
            (res) => { this.setState({ editData: info, teamVisible: true }) }
        );
    }

    //充值
    doRecharge = (info, e) => {
        info.code = info.memberCode;
        info.name = info.memberName;
        this.setState({ editData: info, rechargeVisible: true });
    }

    //扣费
    deduction = (info, e) => {
        info.code = info.memberCode;
        info.name = info.memberName;
        this.setState({ editData: info, deductionVisible: true });
    }

    //详情
    detail = (info, e) => {
        info.code = info.memberCode;
        info.name = info.memberName;
        //查询当前账户的汇总信息
        http.post({
            url: '/tenant/findAccountRecordSummary',
            data: { memberCode: info.code },
            success: (res) => {
                this.setState({ summary: res, editData: info, detailVisible: true });
                this.refs["detail"].loadTableData(info.code, "account");
                this.refs["detail"].loadTableData(info.code, "bond");
            }
        });
    }



    inputSearch = (value) => {
        let queryData = this.state.queryData;
        queryData.memberName = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    orgSelect = (value) => {
        let queryData = this.state.queryData;
        queryData["orgCode"] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={20}>
                                <Input.Search
                                    placeholder="会员名称"
                                    onSearch={this.inputSearch}
                                    enterButton
                                    style={{ width: 400, marginRight: '10px' }}
                                />

                                <TreeSelect onChange={this.orgSelect} treeData={this.state.orgList} allowClear={true}
                                    treeDefaultExpandAll={true} style={{ width: '250px' }} />
                            </Col>
                            <Col span={4} style={{ textAlign: "right" }}>
                                {global_data.authCode.includes("TENANTPROPERTY_ADD")?
                                <Button type="primary" onClick={this.add}>新增</Button>
                                :""}
                            </Col>
                        </Row>
                    )}
                    rowKey="memberCode" url="/tenant/findTenantPage" columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <TenantPropertyEdit
                    visible={this.state.visible}
                    onCancel={this.hiddenModal.bind(this)}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                />
                <MemberPropertyRecharge
                    visible={this.state.rechargeVisible}
                    onCancel={() => { this.setState({ rechargeVisible: false, editData: {} }) }}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                    content="tenant"
                />
                <MemberPropertyDeduction
                    visible={this.state.deductionVisible}
                    onCancel={() => { this.setState({ deductionVisible: false, editData: {} }) }}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                    content="tenant"
                />
                <MemberDetail
                    visible={this.state.detailVisible}
                    onCancel={() => { this.setState({ detailVisible: false, editData: {} }) }}
                    editData={this.state.editData}
                    summary={this.state.summary}
                    ref="detail"
                    content="tenant"
                />
                <MemberTeam
                    visible={this.state.teamVisible}
                    onCancel={() => { this.setState({ teamVisible: false, editData: {} }) }}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                    ref="memberTeam"
                    content="tenant"
                />
            </div>
        )
    }
}

export default TenantProperty;